<template>
    <section class="section-categorias-component py-2">
        <div class="row mx-0 position-relative">
            <cargando v-if="cargando" />
            <!-- Arrows -->
            <div v-if="!dosLineas && productsLineOne.length > 6" class="d-middle-center position-absolute cr-pointer bg-white rounded-circle shadow z-1" style="width:32px;height:32px;left:5px;top:36%;" @click="leftScroll">
                <i class="icon-angle-left text-general f-20" />
            </div>
            <div v-if="!dosLineas && productsLineOne.length > 6" class="d-middle-center position-absolute cr-pointer bg-white rounded-circle shadow z-1" style="width:32px;height:32px;right:50px;top:36%;" @click="rightScroll">
                <i class="icon-angle-right text-general f-20" />
            </div>
            <!-- Arrows -->
            <div class="text-center" style="width:35px;">
                <el-tooltip content="Inactivo" placement="bottom" effect="light">
                    <i v-if="!sectionActive" class="icon-eye-off f-18 text-general cr-pointer" />
                </el-tooltip>
            </div>
            <div id="container" class="col px-0 custom-scroll overflow-auto">
                <div class="row mx-0 align-items-center text-gris2 f-500 mb-2">
                    Sección Productos
                    <span class="ml-4 text-general f-20 f-600">
                        <el-tooltip content="Clics de la sección" placement="bottom" effect="light">
                            <i class="icon-cursor" />
                        </el-tooltip>
                        {{ totalClicks }}
                    </span>
                </div>
                <template v-if="showData">
                    <div :class="`${dosLineas ? 'mb-4' : ''}`" style="display:inline-flex;">
                        <div v-for="(prd, idx) in productsLineOne" :key="idx">
                            <div class="card-producto br-8 mr-4 pt-3">
                                <div class="row mx-0 justify-center">
                                    <img :src="prd.foto" width="90" height="90" class="br-6" />
                                </div>
                                <p class="text-general f-500 f-13 px-2 mt-3">
                                    $0
                                </p>
                                <p class="nombre-producto text-general f-10 px-2">
                                    {{ prd.nombre }}
                                </p>
                                <p class="text-grey f-10 px-2 f-500">
                                    {{ prd.presentacion }}
                                </p>
                                <div class="row mx-0 px-2 mt-2">
                                    <div class="col-12 px-0">
                                        <button type="button" class="btn-general f-10 br-4 f-14 w-100" style="height:24px;">
                                            Añadir
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <p class="f-20 mt-2 text-general text-center f-600">
                                <el-tooltip content="Clics" placement="bottom" effect="light">
                                    <i class="icon-cursor" />
                                </el-tooltip>
                                {{ prd.clicks }}
                            </p>
                        </div>
                    </div>
                    <template v-if="dosLineas">
                        <div class="row mx-0" />
                        <div style="display:inline-flex;">
                            <div v-for="(prd, idx) in productsLineTwo" :key="idx">
                                <div class="card-producto br-8 mr-4 pt-3">
                                    <div class="row mx-0 justify-center">
                                        <img :src="prd.foto" width="90" height="90" class="br-6" />
                                    </div>
                                    <p class="text-general f-500 f-13 px-2 mt-3">
                                        $0
                                    </p>
                                    <p class="nombre-producto text-general f-10 px-2">
                                        {{ prd.nombre }}
                                    </p>
                                    <p class="text-grey f-10 px-2 f-500">
                                        {{ prd.presentacion }}
                                    </p>
                                    <div class="row mx-0 px-2 mt-2">
                                        <div class="col-12 px-0">
                                            <button type="button" class="btn-general f-10 br-4 f-14 w-100" style="height:24px;">
                                                Añadir
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <p class="f-20 mt-2 text-general text-center f-600">
                                    <i class="icon-cursor" />
                                    {{ prd.clicks }}
                                </p>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="row mx-0">
                        <div class="col">
                            <p>Esta sección no contiene elementos</p>
                        </div>
                    </div>
                </template>
            </div>
            <div class="col-auto px-0 d-flex ml-3">
                <button type="button" class="btn-action border mr-2">
                    <el-popover
                    ref="optionsPopover"
                    placement="bottom"
                    trigger="click"
                    width="200"
                    popper-class="p-0 br-none"
                    >
                        <div class="row mx-2 my-2 item-option align-items-center px-3 cr-pointer" @click="emitirAccion('editar')">
                            Editar
                        </div>
                        <div class="row mx-2 my-2 item-option align-items-center px-3 cr-pointer" @click="emitirAccion('ordenar')">
                            Ordenar sección
                        </div>
                        <div v-if="data.estado == 1" class="row mx-2 my-2 item-option align-items-center px-3 cr-pointer" @click="emitirAccion('activar')">
                            Inactivar
                        </div>
                        <div v-if="data.estado == 0" class="row mx-2 my-2 item-option align-items-center px-3 cr-pointer" @click="emitirAccion('inactivar')">
                            Activar
                        </div>
                        <div class="row mx-2 my-2 item-option align-items-center px-3 cr-pointer" @click="emitirAccion('eliminar')">
                            Eliminar
                        </div>
                        <i slot="reference" class="icon-dots-vertical f-20 text-general cr-pointer" />
                    </el-popover>
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import Service from '~/services/landing/landing_admin'
import { mapGetters } from 'vuex'

export default {
    props: {
        dosLineas: {
            type: Boolean,
            default: false
        },

        data:{
            type:Object,
            default:() => {}
        },

        changes:{
            type: Boolean,
            default: false
        }
    },

    data(){
        return {
            cargando: false,
            showData: [],
            productsLineOne: [],
            productsLineTwo: [],
        }
    },

    computed:{
        idSeccion(){
            return this.data.id
        },

        sectionActive(){
            return parseInt(this.data.estado) == 0 ? false : true;
        },

        totalClicks(){
            return _.sumBy(this.productsLineOne, 'clicks') + _.sumBy(this.productsLineTwo, 'clicks')
        },
        ...mapGetters({
            getListenerUpdater: 'landing/landing/getListenerUpdater',
        }),
    },

    watch:{
        changes(){
            this.getData();
        },
        getListenerUpdater(){
            if(this.getListenerUpdater.type === 'actualizarData' && this.getListenerUpdater.value === 'producto' && parseInt(this.getListenerUpdater.idSection) === parseInt(this.idSeccion)){
                this.getData();
            }
        },
    },

    mounted(){
        this.getData();
    },

    methods: {
        async getData(){
            try {
                this.cargando = true;
                const {data} = await Service.detalleSeccion(this.idSeccion);
                if(data.products.length < 1){
                    return this.showData = false;
                }

                this.productsLineOne = [];
                this.productsLineTwo = [];

                if(this.dosLineas){
                    data.products.map((e, index) => {
                        let num = index + 1;
                        e.index = num;
                        if((num % 2) == 0){
                            this.productsLineTwo = [...this.productsLineTwo, e];
                        } else {
                            this.productsLineOne = [...this.productsLineOne, e];
                        }
                    });
                } else {
                    this.productsLineOne = data.products;
                }

                this.showData = true;
            } catch(e){
                this.error_catch(e)
            } finally {
                this.cargando = false;
            }
        },

        leftScroll(){
            let container = document.getElementById('container');
            this.sideScroll(container,'left',25,100,25);
        },

        rightScroll(){
            let container = document.getElementById('container');
            this.sideScroll(container,'right',25,100,25);
        },

        sideScroll(element,direction,speed,distance,step){
            /* let scrollAmount = 0; */
            element.scrollLeft = 50;
            /* if(direction == 'left'){
            } else if( direction == 'right' ){
                element.scrollLeft += step;
            } */
            /* var slideTimer = setInterval(function(){
                scrollAmount += step;
                if(scrollAmount >= distance){
                    window.clearInterval(slideTimer);
                }
            }, speed); */
        },

        emitirAccion(tipo){
            let accion = { tipo:tipo, idSeccion: this.idSeccion, seccion:'producto' };
            this.$refs.optionsPopover.doToggle();
            this.$emit('acciones', accion);
        },
    }
}
</script>

<style lang="scss" scoped>

.section-categorias-component:hover{
    background-color: rgb(220, 242, 252);    
}

.card-producto{
    width: 146px;
    height: 246px;
    background-color: #FFFFFF;
    box-shadow: 0px 3px 6px #0000000D;
    .nombre-producto{
        height: 46px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: pre-line;
        line-height: 19px;
    }
}

</style>